import '../../base/style/index.mjs';
import 'element-plus/theme-chalk/src/collapse.scss';
//# sourceMappingURL=index.mjs.map
